import LicenseManagement from "./LicenseManagement";

export default LicenseManagement